import { Button, Drawer } from '@servicetitan/design-system';

import DiagnosticsModule from '..';
import datetime from '../../../lib/utils/datetime';
import { useDiagnostics } from '../DiagnosticsContext';
import { useMemo } from 'react';

const DiagnosticsDrawer = () => {
  const { errors, events, drawerOpen } = useDiagnostics();

  const handleDiagnosticsDrawerClose = () => {
    DiagnosticsModule.markErrorsAsRead();
    DiagnosticsModule.setDiagnosticsDrawerOpen(false);
  };

  const handleClear = () => {
    DiagnosticsModule.clearItems();
  };

  const combined = useMemo(
    () => [...errors, ...events].sort((a, b) => b.createdAt - a.createdAt),
    [errors, events],
  );

  return (
    <Drawer
      header='Diagnostics'
      backdrop
      open={drawerOpen}
      onClose={handleDiagnosticsDrawerClose}
      footer={
        <Button onClick={handleClear} data-testid='clear-button'>
          Clear
        </Button>
      }
      data-testid='diagnostics-drawer'
    >
      <div data-testid='diagnostics-items'>
        {combined.map((item) => (
          <div
            key={item.id}
            data-testid='diagnostics-item'
          >{`${datetime(item.createdAt).format('D/M h:mma')} [${item.type}]: ${item.message}`}</div>
        ))}
      </div>
    </Drawer>
  );
};

export default DiagnosticsDrawer;
